export const findCountryTranslation = (countryList, locales, iso) => (
  countryList.find(country => {
    const isoMatches = country.iso === iso;
    const localeCodeMatches = locales.includes(country.localeCode.toLowerCase());
    return isoMatches && localeCodeMatches;
  })
);
